/* ============================================================
   HERCULES — FAQ ACCORDION JS
   Pairs with: sections/faq-accordion.liquid
              assets/faq-accordion.css

   Responsibilities:
   - Measure each answer's natural height and set --lp-faq-a-h
     so the CSS can animate max-height smoothly
   - Single-open-at-a-time (optional, opt-in via section setting later)
   - Tag chip filter on page mode: clicking a chip filters groups in/out
   - Open the FAQ matching a deep-link hash (#faq-id) on page load
   ============================================================ */

(function () {
  'use strict';

  function setHeight(detailsEl) {
    var answer = detailsEl.querySelector('.lp-faq__a');
    if (!answer) return;
    // Temporarily expand to measure, then set the variable
    var inner = answer.querySelector('.lp-faq__a-inner');
    if (!inner) return;
    var h = inner.offsetHeight;
    answer.style.setProperty('--lp-faq-a-h', h + 'px');
  }

  function initAccordion(section) {
    var items = section.querySelectorAll('[data-lp-faq-item]');

    Array.prototype.forEach.call(items, function (item) {
      // Measure on init for items that are open by default (none, but defensive)
      if (item.open) {
        setHeight(item);
      }

      // Listen to toggle event for re-measure on open
      item.addEventListener('toggle', function () {
        if (item.open) {
          setHeight(item);
        }
      });
    });

    // Re-measure on window resize for any currently-open items
    var resizeTimer;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        Array.prototype.forEach.call(items, function (item) {
          if (item.open) setHeight(item);
        });
      }, 150);
    });
  }

  function initChips(section) {
    var chips = section.querySelectorAll('[data-lp-faq-chip]');
    var groups = section.querySelectorAll('[data-lp-faq-group]');
    if (chips.length === 0 || groups.length === 0) return;

    Array.prototype.forEach.call(chips, function (chip) {
      chip.addEventListener('click', function () {
        var filter = chip.getAttribute('data-lp-faq-chip');

        // Update chip active state
        Array.prototype.forEach.call(chips, function (c) {
          c.classList.toggle('is-active', c === chip);
        });

        // Show/hide groups
        Array.prototype.forEach.call(groups, function (group) {
          var groupTag = group.getAttribute('data-lp-faq-group');
          if (filter === 'all' || groupTag === filter) {
            group.classList.remove('is-hidden');
          } else {
            group.classList.add('is-hidden');
          }
        });
      });
    });
  }

  function initDeepLink(section) {
    // If URL hash matches a question's id, open it and scroll to it
    if (!window.location.hash) return;
    var target = document.getElementById(window.location.hash.slice(1));
    if (!target) return;
    // Walk up to find the parent <details>
    var details = target.closest('[data-lp-faq-item]');
    if (details) {
      details.open = true;
      setTimeout(function () {
        details.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
    }
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-lp-faq]');
    Array.prototype.forEach.call(sections, function (section) {
      initAccordion(section);
      initChips(section);
      initDeepLink(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on Shopify section reload in theme editor
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target && event.target.querySelector('[data-lp-faq]')) {
        initAll();
      }
    });
  }
})();